export const InsertChildPlayerSameTeam = {
  name: "player",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "player.select",
  showOn: [{ state: "editState", value: "child-insert-same", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["parent"] },
  children: [
    {
      name: "player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      options: {
        currentEntityEvent: "parent",
        currentEntity: true,
        showBench: false,
        showCoach: false,
        excludeOtherEvents: false,
        excludePlayer: true,
        excludeFrom: "parent",
        calculateOnCourt: "after",
      },
      actionGroups: [
        {
          actions: [
            { action: "newEventId", value: null, type: "main" },
            {
              action: "sendEvent",
              value: "edit",
              type: "main",
            },
            { action: "calculateOnCourt" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
